import {
    Answer,
    Publish,
    Tokens,
    PortalPublish,
    KioskAnswerStorage,
    AnswerItem,
    AnswerStatus,
    FormDetail,
    UserData,
    Form,
    WorkspacesStorage,
} from 'interface';

// local storage interface
export const authToken = {
    key: 'UCHECK_APP_AUTH_TOKEN',
    get: function (): Tokens | null {
        const data = localStorage.getItem(authToken.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: Tokens) => {
        localStorage.setItem(authToken.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(authToken.key);
    },
};

export const serverAddress = {
    key: 'APP_SERVER_ADDRESS',
    get: function (): string | null {
        return localStorage.getItem(serverAddress.key);
    },
    set: (value: string) => {
        localStorage.setItem(serverAddress.key, value);
    },
    remove: () => {
        localStorage.removeItem(serverAddress.key);
    },
};

export const userData = {
    key: 'APP_QUESTIONER_USER_DATA',
    get: function (): UserData | null {
        const data = localStorage.getItem(userData.key);
        if (data && data.length) return JSON.parse(data);
        else return null;
    },
    set: (value: UserData) => {
        localStorage.setItem(userData.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(userData.key);
    },
};

export const viewId = {
    key: 'VIEW_ID',
    get: function (): string | null {
        const view = localStorage.getItem(viewId.key);
        if (view === undefined || view === null || isNaN(parseInt(view))) return null;
        else return view;
    },
    set: (value: string) => {
        localStorage.setItem(viewId.key, value);
    },
    remove: () => {
        localStorage.removeItem(viewId.key);
    },
};

export const kioskData = {
    key: 'KIOSK_PUBLISH',
    get: function (): Publish | null {
        const data = localStorage.getItem(kioskData.key);
        if (data && data.length) return JSON.parse(data);
        else return null;
    },
    set: (value: Publish) => {
        localStorage.setItem(kioskData.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(kioskData.key);
    },
};

export const portalData = {
    key: 'PORTAL_PUBLISH',
    get: function (): PortalPublish | null {
        const data = localStorage.getItem(portalData.key);
        if (data && data.length) return JSON.parse(data);
        else return null;
    },
    set: (value: PortalPublish) => {
        localStorage.setItem(portalData.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(portalData.key);
    },
};

export const kioskCode = {
    key: 'KIOSK_CODE',
    get: function (): number | null {
        const data = localStorage.getItem(kioskCode.key);
        if (data && data.length) return JSON.parse(data);
        else return null;
    },
    set: (value: number) => {
        localStorage.setItem(kioskCode.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(kioskCode.key);
    },
};

export const registeredId = {
    key: 'REGISTERED_ID',
    get: function (): string | null {
        const data = localStorage.getItem(registeredId.key);
        if (data && data.length) return JSON.parse(data);
        else return null;
    },
    set: (value: string) => {
        localStorage.setItem(registeredId.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(registeredId.key);
    },
};

export const kioskAnswers = {
    key: 'KIOSK_ANSWERS',
    setAnswerAsComplete: (id: number, date: string) => {
        const data: Answer[] = kioskAnswers.getAll();
        const answerIndex = data.findIndex((item) => item.id === id);
        if (answerIndex > -1 && answerIndex !== undefined) {
            data[answerIndex].end_date = date;
            data[answerIndex].state = AnswerStatus.complete;
            console.log(data[answerIndex]);
        }
        console.log(answerIndex);
        kioskAnswers.set(data);
    },
    addAnswer: (id: number, date: string, form: FormDetail) => {
        const newData: Answer[] = kioskAnswers.getAll();
        newData.push({
            id,
            created_at: date,
            modified_at: date,
            items: [],
            state: AnswerStatus.incomplete,
            questionerOffline: true,
            form,
            publish: 0,
        });
        kioskAnswers.set(newData);
    },
    getAll: function (): Answer[] {
        const data = localStorage.getItem(kioskAnswers.key);
        if (data && data.length) return JSON.parse(data);
        else return [];
    },
    set: function (data: Answer[]) {
        localStorage.setItem(kioskAnswers.key, JSON.stringify(data));
    },
    setAnswerItem: function (answerID: number, item: AnswerItem) {
        const data: Answer[] = kioskAnswers.getAll();
        const index = data.findIndex((item) => item.id === answerID);
        if (index === undefined || index < 0) return;
        const itemIndex = data[index].items.findIndex((data) => data.question.id === item.question.id);
        if (itemIndex === undefined || itemIndex < 0) data[index].items.push(item);
        else data[index].items[itemIndex] = item;
        kioskAnswers.set(data);
    },
    removeAnswer: function (answerId: number) {
        let data: Answer[] = kioskAnswers.getAll();
        data = [...data.filter((item) => item.id !== answerId)];
        kioskAnswers.set(data);
    },
    checkAnswerCreationStatus: function (answerID: number): boolean {
        const data: Answer[] = kioskAnswers.getAll();
        const createdAt = data.find((item) => item.id === answerID)?.questionerOffline;
        return createdAt ? true : false;
    },
};

export const portalAnswers = {
    key: 'PORTAL_ANSWERS',
    addAnswer: (id: number, date: string, form: number, publish: string) => {
        const newData: KioskAnswerStorage[] = portalAnswers.getAll();
        newData.push({
            id,
            created_at: date,
            modified_at: date,
            items: [],
            state: AnswerStatus.incomplete,
            questionerOffline: true,
            form,
            publish,
        });
        portalAnswers.set(newData);
    },
    getAll: function (): KioskAnswerStorage[] {
        const data = localStorage.getItem(portalAnswers.key);
        if (data && data.length) return JSON.parse(data);
        else return [];
    },
    set: function (data: KioskAnswerStorage[]) {
        localStorage.setItem(portalAnswers.key, JSON.stringify(data));
    },
    setAnswerItem: function (answerID: number, item: AnswerItem) {
        const data: KioskAnswerStorage[] = portalAnswers.getAll();
        const index = data.findIndex((item) => item.id === answerID);
        if (index === undefined || index < 0) return;
        const itemIndex = data[index].items.findIndex((data) => data.question.id === item.question.id);
        if (itemIndex === undefined || itemIndex < 0) data[index].items.push(item);
        else data[index].items[itemIndex] = item;
        portalAnswers.set(data);
    },
    removeAnswer: function (answerId: number) {
        let data: KioskAnswerStorage[] = portalAnswers.getAll();
        data = [...data.filter((item) => item.id !== answerId)];
        portalAnswers.set(data);
    },
    checkAnswerCreationStatus: function (answerID: number): boolean {
        const data: KioskAnswerStorage[] = portalAnswers.getAll();
        const createdAt = data.find((item) => item.id === answerID)?.questionerOffline;
        return createdAt ? true : false;
    },
};

export const WSData = {
    key: 'APP_WORKSPACE_DATA',
    get: function (): WorkspacesStorage[] | null {
        const data = localStorage.getItem(WSData.key);
        if (data && data.length) return JSON.parse(data);
        else return null;
    },
    set: (value: WorkspacesStorage[]) => {
        const getCircularReplacer = () => {
            const seen = new WeakSet();
            return (_, value: any) => {
                if (typeof value === 'object' && value !== null) {
                    if (seen.has(value)) {
                        return;
                    }
                    seen.add(value);
                }
                return value;
            };
        };
        localStorage.setItem(WSData.key, JSON.stringify(value, getCircularReplacer()));
    },
    remove: () => {
        localStorage.removeItem(WSData.key);
    },
    getForm: (formId: number | string) => {
        const data = WSData.get();
        const allForms: Form[] = [];
        data?.map((i) => i.forms.map((j) => allForms.push(j)));
        const index = allForms.findIndex((item) => item.id === Number(formId));
        if (index === undefined || index < 0) return null;
        return allForms[index];
    },
};

export const publishDataStatus = {
    key: 'PUBLISH_STATE_KEEPER',
    stored: () => {
        localStorage.setItem(publishDataStatus.key, '1');
    },
    removed: () => {
        localStorage.removeItem(publishDataStatus.key);
    },
    isStored: () => {
        const data = localStorage.getItem(publishDataStatus.key);
        return data === '1';
    },
};

export const userFormDataStatus = {
    key: 'USER_FORMS_STATUS_KEEPER',
    stored: (id: number) => {
        const data = userFormDataStatus.get();
        if (!data.includes(id)) data.push(id);
        userFormDataStatus.set(data);
    },
    get: (): number[] => {
        const str = localStorage.getItem(userFormDataStatus.key);
        if (str && str.length > 0) return str.split(',').map((i) => Number(i));
        else return [];
    },
    set: (value: number[]) => {
        localStorage.setItem(userFormDataStatus.key, value.join(','));
    },
    isStored: (id: number) => {
        return userFormDataStatus.get().includes(id);
    },
    remove: () => {
        localStorage.removeItem(userFormDataStatus.key);
    },
};
